import { createAsyncThunk } from "@reduxjs/toolkit";
import organizationDataAccess from "src/dataAccess/organizations/organization.dataaccess";
import { IListType } from "../store";

export const GetOrganizationList = createAsyncThunk<any, IListType>(
  "[Organization] Get Organization List",
  async (parameter, thunkAPI) => {
    const result = await organizationDataAccess
      .getList(parameter)
      .then((res) => res);
    return result;
  }
);
